import fetchTourRatings from './tourRatingSaga';
import fetchTourDetails from "./fetchTourDetailsSaga";
import fetchTourInsights from "./fetchTourInsightSaga";
import fetchTourHighlights from "./fetchTourHighlightsSaga";

export default [...fetchTourRatings, ...fetchTourDetails, ...fetchTourInsights, ...fetchTourHighlights];
